import { render, staticRenderFns } from "./LegacyLayoutFluid.vue?vue&type=template&id=4c1b001b&"
import script from "./LegacyLayoutFluid.vue?vue&type=script&lang=js&"
export * from "./LegacyLayoutFluid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports